import { Phase4 } from '@indigo-ag/schema';

export class Phase4Util {
  static assignedToFund(phase4: Phase4): boolean {
    return !!phase4.sentToFundAt && !!phase4.assignedToCreditAt
      ? phase4.sentToFundAt > phase4.assignedToCreditAt
      : !!phase4.sentToFundAt;
  }

  static receivedByFund(phase4: Phase4): boolean {
    return !!phase4.receivedByFundAt && !!phase4.assignedToCreditAt
      ? phase4.receivedByFundAt > phase4.assignedToCreditAt
      : !!phase4.receivedByFundAt;
  }

  static awaitingManagerApproval(phase4: Phase4): boolean {
    return !!phase4.sentToManagerAt && !!phase4.assignedToCreditAt
      ? phase4.sentToManagerAt > phase4.assignedToCreditAt
      : !!phase4.sentToManagerAt;
  }

  static submitted(phase4: Phase4): boolean {
    return !!phase4.submittedAt;
  }
}
